"use client";
import React from "react";
import {
  VictoryChart,
  VictoryLine,
  VictoryScatter,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
} from "victory";

var humanFormat = require("human-format");

const dataSetOne = [
  { x: "Jan", y: 5 },
  { x: "Feb", y: 6 },
  { x: "Mar", y: 4 },
  { x: "Apr", y: 10 },
  { x: "May", y: 12 },
  { x: "Jun", y: 48 },
  { x: "Jul", y: 19 },
  { x: "Aug", y: 31 },
  { x: "Sep", y: 49 },
  { x: "Oct", y: 40 },
  { x: "Nov", y: 21 },
  { x: "Dec", y: 21 },
];

class VictoryMap extends React.Component {
  constructor(props) {
    super(props);
    this.onActivated = this.updatePoint.bind(this);
    this.state = {
      ChartData: [],
      point: {},
      valueX: "",
      valueY: "",
      activePoints: [],
      minvalue: 0,
      maxvalue: 0,
    };
    this.labelClick = this.labelClick.bind(this);
    this.onActivePoints = this.activatePoint.bind(this);
    this.outsideDive = this.outsideDive.bind(this);
  }

  labelClick = (value) => {};

  updatePoint(points) {
    this.setState({ point: points[0] });
  }

  activatePoint(point) {
    this.setState({ activePoints: [point[0]] });
    this.setState({ point: point[0] });
  }

  outsideDive = (e) => {
    this.setState({ activePoints: [] });
  };

  componentDidMount = () => {
    const { medianPrice = "" } = this.props;
    const myArray = medianPrice && medianPrice !== "" ? medianPrice.split(",") : [];
    const parsedArray = myArray.map((val) => parseFloat(val) || 0);
    const minvalue = parsedArray.length > 0 ? Math.min(...parsedArray) : 0;
    const maxvalue = parsedArray.length > 0 ? Math.max(...parsedArray) : 0;

    this.setState({ minvalue, maxvalue });

    const fullMonths = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const now = new Date();
    const months = [];
    const currentMonthIndex = now.getMonth() - 1;
    const currentYear = now.getFullYear();

    for (let i = 11; i >= 0; i--) {
      const date = new Date(currentYear, currentMonthIndex - i, 1);
      const month = fullMonths[date.getMonth()];
      const year = date.getFullYear();
      months.push(`${month} ${year}`);
    }

    const newArray = [];
    for (let i = 0; i < 12; i++) {
      newArray.push({
        x: months[i],
        y: parsedArray[i] || 0,
      });
    }

    const chartData = newArray.length > 0 ? newArray : dataSetOne;

    this.setState({
      ChartData: chartData,
      valueX: chartData[0]?.x || "",
      valueY: chartData[0]?.y || "",
    });
  };

  render() {
    const styles = this.getStyles();
    const { minvalue, maxvalue } = this.state;

    const yDomain =
      minvalue !== maxvalue
        ? [
            minvalue - (maxvalue - minvalue) * 0.4,
            maxvalue + (maxvalue - minvalue) * 0.3,
          ]
        : [minvalue - 5, maxvalue + 5];

    return (
      <div onMouseLeave={this.outsideDive}>
        <VictoryChart
          domain={{ y: yDomain }}
          width={700}
          domainPadding={20}
          padding={{ top: 25, bottom: 25, right: 70, left: 10 }}
          containerComponent={
            <VictoryVoronoiContainer
              responsive={true}
              onActivated={this.onActivePoints}
              voronoiBlacklist={["activepoints", "horizontalLine"]}
              labels={(d) =>
                d.datum.x + ", " + "$" + `${humanFormat(parseInt(d.datum.y))}`
              }
              labelComponent={
                <VictoryTooltip
                  orientation="top"
                  constrainToVisibleArea
                  cornerRadius={0}
                  flyoutStyle={{
                    fill: "white",
                    stroke: "rgb(153 153 153 / 35%)",
                  }}
                  style={styles.tooltipBox}
                />
              }
            />
          }
        >
          <VictoryAxis
            standalone={false}
            style={styles.axisYears}
            tickCount={5}
          />
          <VictoryAxis
            dependentAxis
            orientation="right"
            tickFormat={(t) => "$" + `${humanFormat(parseInt(t))}`}
            standalone={false}
            style={styles.axisOne}
          />
          <VictoryLine
            data={this.state.ChartData}
            standalone={false}
            style={styles.lineTwo}
            interpolation="monotoneX"
          />
          {this.state.activePoints.length ? (
            <VictoryScatter
              name="activepoints"
              data={this.state.activePoints}
            />
          ) : null}
          {this.state.activePoints.length ? (
            <VictoryLine
              name="horizontalLine"
              data={[
                {
                  x: this.state.activePoints[0].x,
                  y: 0, // use padded min
                },
                {
                  x: this.state.activePoints[0].x,
                  y: maxvalue + (maxvalue - minvalue) * 0.4, // use padded max
                },
              ]}
              style={styles.lineThree}
            />
          ) : null}
        </VictoryChart>
      </div>
    );
  }

  getStyles() {
    const BLACK_COLOR = "#000000";
    return {
      tooltipBox: {
        fill: "#999999",
        fontSize: "15px",
        padding: "10px",
      },
      labelName: {
        textAnchor: "middle",
        fill: "#999999",
        fontFamily: "inherit",
        fontSize: "20px",
        textDecoration: "underline",
        padding: "10px",
        cursor: "pointer",
      },
      axisYears: {
        axis: { stroke: "#E2E2E2", strokeWidth: 1 },
        tickLabels: {
          fill: "#999999",
          fontFamily: "inherit",
          fontSize: 14,
        },
      },
      axisOne: {
        grid: {
          stroke: ({ tick }) => "#E2E2E2",
          strokeWidth: 1,
        },
        axis: { stroke: "#999999", strokeWidth: 0 },
        tickLabels: {
          fill: "#999999",
          fontFamily: "inherit",
          fontSize: 14,
        },
      },
      lineTwo: {
        data: { stroke: BLACK_COLOR, strokeWidth: 2 },
      },
      lineThree: {
        data: { stroke: "rgb(101, 192, 207)", strokeWidth: 2 },
      },
    };
  }
}

export default VictoryMap;
